import colors from "../colors";
import ramp from "../ramp";

export var scheme = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(colors);

export default ramp(scheme);



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale-chromatic/src/sequential-single/Blues.js
// module id = jpg6
// module chunks = 0